export class MathUtil {
  public static toNegative = (n: number) => -Math.abs(n);
}
